import UsersTableHelper from './user-table-helper';
import usersFuncHelper from './user-functions-helper';


const UsersHelpers = {
    TableMain: UsersTableHelper,
    Functions: usersFuncHelper,
};

export default UsersHelpers;